import { type AnyAction } from 'redux';
import { setViewedUser } from './viewed-user-actions';

export default function viewedUser(state = null, action: AnyAction) {
  switch (action.type) {
    case setViewedUser.type:
      return action.payload;
    default:
      return state;
  }
}
